import React from "react";
import styles from "./index.module.scss";
// import MobileCarousel from "./mobile-carousel";
import DesktopGrid from "./desktop-grid";
import { PrismicRichText } from "@prismicio/react";

const TypicalLoanTerms = ({ data }) => {
  const loanTerms = data?.loan_terms_cards;
  return (
    <section className={styles.loanTermsPage}>
      <div className={styles.mainSection}>
        <div className={`${styles.container}`}>
          {/* Title Section */}
          <div className={`${styles.titleSection} container`}>
            <div className={styles.mainTitle}>
              <PrismicRichText field={data?.loan_terms_title} />
            </div>
            <div className={styles.subtitle}>
              <PrismicRichText field={data?.loan_terms_description} />
            </div>
          </div>
          {/*<MobileCarousel loanTerms={loanTerms} />*/}
          <DesktopGrid loanTerms={loanTerms} />
        </div>
      </div>
    </section>
  );
};

export default TypicalLoanTerms;
